/**
 * Instructions module routes — moved verbatim from router/index.tsx.
 */

import { type RouteObject } from 'react-router-dom';
import { PK } from '@/constants/permissions';
import { ROUTES } from '@/constants';
import { lazyWithRetry } from '@/utils/lazyWithRetry';
import { PermissionRoute } from '../PermissionRoute';

const InstructionsPage = lazyWithRetry(() => import('@/features/directory/pages/InstructionsPage'));
const InstructionFormPage = lazyWithRetry(() => import('@/features/instructions/pages/InstructionFormPage'));

export const instructionsRoutes: RouteObject[] = [
      // --------------------------------
      // Instructions Module
      // --------------------------------
      {
        path: ROUTES.instructions.list,
        element: (
          <PermissionRoute permission={PK.Instructions.View}>
            <InstructionsPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.instructions.details,
        element: (
          <PermissionRoute permission={PK.Instructions.View}>
            <InstructionsPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.instructions.create,
        element: (
          <PermissionRoute permission={PK.Instructions.Create}>
            <InstructionFormPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.instructions.edit,
        element: (
          <PermissionRoute permission={PK.Instructions.Edit}>
            <InstructionFormPage />
          </PermissionRoute>
        ),
      },
];
